import { AppState } from "@/context/appContext";

const RENDER_ORDER_Z_INDEX_OFFSET = 1;

export const renderOrderToZindexMap = (renderOrder: string[]) => {
    const newZIndexMap: Record<string, number> = {};

    renderOrder.forEach((id, index) => {
      newZIndexMap[id] = index + RENDER_ORDER_Z_INDEX_OFFSET; // Assign z-index based on position in renderOrder
    });
    
    return newZIndexMap;
}

export const addObjectToAppState = (appState: AppState, id: string) => {
    const newRenderOrder = [...appState.pdfObjectsRenderOrder, id];

    return {
        ...appState,
        pdfObjectsRenderOrder: newRenderOrder,
        pdfOBjectsZIndexMap: renderOrderToZindexMap(newRenderOrder)
    }
}

export const getMaxZIndex = (renderOrder: string[]) => {
    return renderOrder.length + RENDER_ORDER_Z_INDEX_OFFSET;
}